import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private readonly resourceUrl = '/payment';

  constructor(private api: ApiService) {}

  getStripeSessionId(
    applicationAssessment: boolean,
    body: any,
    isRecurring = false
  ): Observable<any> {
    body = this.formatBody(body, isRecurring);
    if (applicationAssessment) return this.api.post(`${this.resourceUrl}/yearlyPurchase`, body);
    return this.api.post(`${this.resourceUrl}${isRecurring ? '/subscribe' : '/purchase'}`, body);
  }

  submitOfflinePayment(body: any): Observable<any> {
    body = this.formatBody(body);
    return this.api.post(`${this.resourceUrl}/offlineTransfers`, body);
  }

  getPurchaseStatus(sessionId: string, confirmed: boolean, isRecurring = false): Observable<any> {
    const handlerRoute: string = confirmed
      ? isRecurring
        ? 'subscriptionSuccessHandler'
        : 'successHandler'
      : isRecurring
      ? 'subscriptionCancelHandler'
      : 'cancelHandler';
    return this.api.post(`${this.resourceUrl}/${handlerRoute}`, null, { sessionId });
  }

  getLinkToken(): Observable<any> {
    return this.api.get(`${this.resourceUrl}/linkToken`);
  }

  exchangeToken(body): Observable<any> {
    return this.api.post(`${this.resourceUrl}/exchangeToken`, body);
  }

  cancelSubscription(body: string): Observable<any> {
    return this.api.post(`${this.resourceUrl}/cancelSubscription`, body);
  }

  private formatBody(body: any, isRecurring = false): any {
    const stripRecurringFields = (obj: any): any => {
      delete obj.recurrencePattern;
      delete obj.startDate;
      delete obj.endDate;
      delete obj.charity;
      return obj;
    };
    return isRecurring ? body : stripRecurringFields(body);
  }
}
